export function authenticatedPost(url, body, state) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + state.auth.token
    },
    body: JSON.stringify(body),
  });
}


// WEBPACK FOOTER //
// ./src/state/utilities.js